// Theme configuration - update these values to change the entire site's branding
// 4KMatch Brand Colors
export const theme = {
  colors: {
    // Primary colors - Vibrant Red
    primary: "#ff2700", // 4KMatch primary red
    primaryHover: "#ff4d2a", // Lighter red for hover
    primaryDark: "#cc1f00", // Darker red for active

    // Secondary accent - Magenta Pink
    secondary: "#ff00a8", // 4KMatch magenta
    secondaryDark: "#cc0087",

    // Background colors (dark theme with depth)
    bgPrimary: "#000000", // Pure black
    bgSecondary: "#0A0A0A", // Near black
    bgTertiary: "#141414", // Dark grey
    bgElevated: "#1E1E1E", // Elevated elements
    bgCard: "#0D0D0D", // Card backgrounds

    // Text colors
    textPrimary: "#FFFFFF", // Primary text - white
    textSecondary: "#A0A0A0", // Secondary text - muted
    textMuted: "#666666", // Muted text - very subtle

    // Brand utility colors
    grey: "#e9e9e9", // 4KMatch grey
    black: "#4a4a4a", // 4KMatch black

    // Accent colors
    accent: "#ff2700",
    accentGlow: "rgba(255, 39, 0, 0.4)",
    accentGlowStrong: "rgba(255, 39, 0, 0.6)",

    // Energy gradients - Primary to Secondary flow
    gradientPrimary: "linear-gradient(135deg, #ff2700 0%, #ff00a8 100%)",
    gradientSecondary: "linear-gradient(135deg, #ff00a8 0%, #ff2700 100%)",
    gradientDark: "linear-gradient(180deg, #141414 0%, #000000 100%)",
    gradientRadial:
      "radial-gradient(circle at center, rgba(255, 39, 0, 0.15) 0%, transparent 70%)",
    gradientVibrant: "linear-gradient(90deg, #ff2700 0%, #ff00a8 50%)",

    // Utility colors
    success: "#01ff06", // 4KMatch green highlight
    error: "#FF3366",
    warning: "#FFB800",

    // Border colors
    border: "#222222",
    borderLight: "#333333",
    borderGlow: "rgba(255, 39, 0, 0.5)",
  },

  fonts: {
    primary:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    heading:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    display:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },

  fontSizes: {
    xs: "0.75rem", // 12px
    sm: "0.875rem", // 14px
    base: "1rem", // 16px
    lg: "1.125rem", // 18px
    xl: "1.25rem", // 20px
    "2xl": "1.5rem", // 24px
    "3xl": "2rem", // 32px
    "4xl": "2.5rem", // 40px
    "5xl": "3.5rem", // 56px
    "6xl": "4.5rem", // 72px
    "7xl": "6rem", // 96px
  },

  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },

  spacing: {
    xs: "0.25rem", // 4px
    sm: "0.5rem", // 8px
    md: "1rem", // 16px
    lg: "1.5rem", // 24px
    xl: "2rem", // 32px
    "2xl": "3rem", // 48px
    "3xl": "4rem", // 64px
    "4xl": "6rem", // 96px
    "5xl": "8rem", // 128px
  },

  borderRadius: {
    sm: "0.25rem", // 4px
    md: "0.5rem", // 8px
    lg: "0.75rem", // 12px
    xl: "1rem", // 16px
    "2xl": "1.5rem", // 24px
    "3xl": "2rem", // 32px
    full: "9999px",
  },

  shadows: {
    sm: "0 2px 4px rgba(0, 0, 0, 0.5)",
    md: "0 4px 12px rgba(0, 0, 0, 0.6)",
    lg: "0 8px 24px rgba(0, 0, 0, 0.7)",
    xl: "0 16px 48px rgba(0, 0, 0, 0.8)",
    glow: "0 0 30px rgba(255, 39, 0, 0.4)",
    glowLg: "0 0 60px rgba(255, 39, 0, 0.5)",
    glowXl: "0 0 100px rgba(255, 39, 0, 0.6)",
    glowSecondary: "0 0 30px rgba(255, 0, 168, 0.4)",
    glowSuccess: "0 0 30px rgba(19, 245, 91, 0.4)",
    inner: "inset 0 2px 4px rgba(0, 0, 0, 0.5)",
  },

  transitions: {
    fast: "150ms cubic-bezier(0.4, 0, 0.2, 1)",
    base: "250ms cubic-bezier(0.4, 0, 0.2, 1)",
    slow: "400ms cubic-bezier(0.4, 0, 0.2, 1)",
    bounce: "500ms cubic-bezier(0.68, -0.55, 0.265, 1.55)",
    spring: "600ms cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  },

  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
  },

  zIndex: {
    base: 0,
    dropdown: 100,
    sticky: 200,
    modal: 300,
    tooltip: 400,
  },
};

export type Theme = typeof theme;
export default theme;
